/* eslint-disable import/no-cycle */
// actions
import { captureAppState } from '../../App/actions';
import { toggleEditPlaces, removePlacesField } from '../../Places/actions';
import { fetchDirections } from '../../Directions/actions';
import { prefetchDestinationChargers } from '../../DestinationChargers/actions';
import {
  updateSuperchargersChargers,
  updateSuperchargersRoutechargers,
} from '../../Superchargers/actions';

// helpers
import { makeActionCreator } from '../../../lib/Utils';

export const ROUTEBTN_UPDATE_LABEL = 'ROUTEBTN_UPDATE_LABEL';
export const updateRouteBtnTitle = makeActionCreator(
  ROUTEBTN_UPDATE_LABEL,
  'label',
);

export const ROUTEBTN_UPDATE_CLASS = 'ROUTEBTN_UPDATE_CLASS';
export const updateRouteBtnBody = makeActionCreator(
  ROUTEBTN_UPDATE_CLASS,
  'className',
);

export const ROUTEBTN_UPDATE_ALL = 'ROUTEBTN_UPDATE_ALL';
export const updateRouteBtnAll = makeActionCreator(ROUTEBTN_UPDATE_ALL, 'data');

export function getRoute(fields, vehicle) {
  // eslint-disable-next-line arrow-parens
  return dispatch => {
    // eslint-disable-next-line arrow-parens
    const validFields = fields.filter(field => {
      if (field.lat !== 0 && field.lng !== 0) return true;

      dispatch(removePlacesField(field));

      return false;
    });

    // pre-fetch destination chargers
    const fieldsLen = fields.length;
    if (fields[fieldsLen - 1].lat !== 999) {
      // eslint-disable-next-line nonblock-statement-body-position
      dispatch(prefetchDestinationChargers());
    }

    dispatch(fetchDirections(validFields, vehicle));
    dispatch(toggleEditPlaces(false));
    dispatch(captureAppState({}));
    dispatch(updateSuperchargersChargers(false));
    dispatch(updateSuperchargersRoutechargers([]));
  };
}
